<div style="display: flex; flex-direction: column">
  <div class="wrapper" id="resultSearchWrapper" >
    <div [ngClass]="appContext.siteName === 'Sharecare' ? 'sharecare-search-wrapper {{ enableSearchBox }}' : 'search-wrapper {{ enableSearchBox }}'  "  >
      <div class="autosuggest" *ngIf="enableSearchBox">
        <div
          *ngIf="isHandset"
          #autosuggest
          id="selectedOption"
          (click)="toggleAutosuggest()"
        >
          <span class="location-icon"> <i class="fa fa-search"></i> </span>
          <span
            [ngClass]="
              appContext.siteName == 'HotelCollection'
                ? 'hc-search-placeholder'
                : 'search-placeholder'
            "
          >
            {{
              locationOption && locationOption.fullName
                ? locationOption.fullName
                : "Enter city name, airport, hotel, or landmark"
            }} </span
          >&nbsp;&nbsp;
          <i *ngIf="locationOption.fullName" class="fa fa-pencil"></i>
        </div>
        <travel-ui-autosuggest
          *ngIf="!isHandset"
          (close)="isOpened = false"
          [isOpened]="isOpened"
          (openedFromInside)="setIsOpenedFlag($event)"
          [stringToShow]="locationOption.fullName"
          [showLoader]="showAutosuggestLoader"
          (click)="toggleAutosuggestDesktop()"
        >
          <div class="lbl-category">
            <div
              class="option"
              *ngFor="let option of autosuggestOptions"
              (click)="getClickedOption(option)"
            >
              <i
                class="fa {{
                  typeAndIconMapping[option.type] || 'fa-map-marker'
                }}"
              ></i>
              <span
                innerHTML="{{ option.fullName | textHighlighter : searchStr }}"
              ></span>
            </div>
          </div>
        </travel-ui-autosuggest>
      </div>
      <div class="datepicker" (click)="toggleDatePicker()" #datePicker>
        <div class="calendar-container">
          <div class="icon-container">
            <span class="icon"> 
               <i *ngIf="appContext.siteName !== 'Sharecare'" class="fa fa-calendar-o"></i>
               <i *ngIf="appContext.siteName === 'Sharecare'" class="fa fa-calendar" style="color: #00bfa5;" ></i> 
            </span>
          </div>
          <div class="date-container">
            <span class="date roboto-regular"> {{ startDate }} </span>
            <div class="dash-icon-container">
              <div class="dash-icon"></div>
            </div>
            <span class="date roboto-regular"> {{ endDate }} </span>
          </div>
        </div>
      </div>

      <div
        (click)="toggleRoomPicker()"
        [ngClass]="{ 'active-control': isRoomPickerOpened }"
        #roomPicker
        class="room-picker"
      >
        <div class="icon-person"><i *ngIf="appContext.siteName !== 'Sharecare'" class="fa fa-user-o"></i>
          <i *ngIf="appContext.siteName === 'Sharecare'" class="fa fa-user" style="color: #00bfa5;" ></i>
        </div>
        <div class="passenger-count">
          <span class="count roboto-regular">{{ passengerCount["Rooms"] }} Rooms</span>
          <span class="dotted-icon"></span>
          <span class="count roboto-regular">{{ passengerCount["Adults"] }} Adults</span>
          <span class="dotted-icon"></span>
          <span class="count roboto-regular">{{ passengerCount["Children"] }} Children</span>
        </div>
      </div>
      <div class="btn-submit-criteria d-flex">
        <button
          [disabled]="submitBtnDisabled"
          [ngClass]="{ 'btn-disabled': submitBtnDisabled, 'sharecare-submit-btn  raleway-semibold': appContext.siteName === 'Sharecare', 'btn-disabled-Sharecare': submitBtnDisabled && appContext.siteName === 'Sharecare' }"
          (click)="submitSearch()"
        >
        <i *ngIf="appContext.siteName === 'Sharecare'" class="fa fa-search mr-5" style="color: #ffffff;font-weight: 300;" ></i>
       <span [ngClass]="{'sharecare-btn-text': appContext.siteName === 'Sharecare'}"> {{ enableSearchBox ?   "Search" : "Check rates"}}</span>
        </button>
      </div>
    </div>
  </div>

  <div
    style="padding: 0.1rem"
    *ngIf="appContext.siteName == 'Zuna'"
  >
    <div class="columclass">
      <div class="mat-padding-right-nation">
        <mat-form-field class="mat-width">
          <mat-label>Nationality</mat-label>
          <mat-select [(value)]="nationality">
            <mat-option
              (click)="onChangeNationality()"
              [value]="option.code"
              *ngFor="let option of countryList"
              >{{ option.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="mat-padding-right">
        <mat-form-field class="mat-width">
          <mat-label>Country of residence</mat-label>
          <mat-select [(value)]="countryOfResidence">
            <mat-option
              (click)="onChangeNationality()"
              [value]="option.code"
              *ngFor="let option of countryList"
              >{{ option.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>

      <div class="advance-div" *ngIf="appContext.siteName == 'Zuna'">
        <button
          *ngIf="!advanceSearch"
          class="pnr-button"
          (click)="advanceSearch = !advanceSearch"
        >
          Advance Search
        </button>
        <div *ngIf="advanceSearch">
          <input
            style="padding: 5px"
            [(ngModel)]="pnrNumber"
            placeholder="enter PNR number"
          />
        </div>
      </div>
    </div>
  </div>
</div>
